module.exports = __webpack_public_path__ + "img/vestel-venus-v3.e5e66121.jpg";